import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';
import { ESTATUS_AUTORIZADO } from 'utils/constants';

export const baseURI = 'catalogos/prestacion-para-nombramiento';

/**
 * GET Tipos de Identificaciones
 * @returns {Promise<object[]>}
 */
export const getPrestacionesNombramientos = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET PrestacionNombramiento
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getPrestacionNombramiento = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST PrestacionNombramiento
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postPrestacionNombramiento = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH PrestacionNombramiento
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchPrestacionNombramiento = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE PrestacionNombramiento
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deletePrestacionNombramiento = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * AUTORIZAR PrestacionNombramiento
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const autorizarPrestacionNombramiento = async (id) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, { estados_globales: ESTATUS_AUTORIZADO });
    onSuccess(response, 'Autorizado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};
